import { PROFILES_DOMAIN } from './domain'
import { PROFILES_KEY } from './key'

export const PROFILES_PATH = {
  ALL: `${PROFILES_DOMAIN}.${PROFILES_KEY.ALL}`,
  CURRENT: `${PROFILES_DOMAIN}.${PROFILES_KEY.CURRENT}`,
  DATA: `${PROFILES_DOMAIN}.${PROFILES_KEY.DATA}`
}
